import React,{useContext} from "react";
import noteContext from "../context/notes/noteContext";

const Noteitem = (props) => {
  const context = useContext(noteContext);
  const { deleteNote } = context;
  const { note,updateNote } = props;
  return (
    <div className="col-md-3 ">
      <div className="card my-3 bg-primary ">
        <div className="card-body   border border-primary rounded">
          <h5 className="card-title">{note.title}</h5>
          <p className="card-text">  {note.description}</p>
            <i className="fa-solid fa-trash mx-2" onClick={()=>{deleteNote(note._id);
            props.showAlert("Deleted Successfully","success")}}></i>
          <i className="fa-solid fa-pen-to-square" onClick={()=>{updateNote(note)}}></i>
          
        </div>
      </div>
    </div>
  );
};

export default Noteitem;
